import '../../vendor/modaal.js';
import { setupAdvisorModal } from './advisor-modal.js';
import { setupBreadcrumbs } from './breadcrumbs.ts';
import { setupCampaignPhone } from './campaign-phone.ts';
import './clickMenu.js';
import { setupFindAgent } from './find-agent.ts';
import { setupFooter } from './footer.ts';
import { setupLazyLoad } from './lazy-load.ts';
import { setupMainNav } from './main-nav.js';
import { setupPersistentBanner } from './persistent-banner.ts';
import { stickyHeader } from './stick-header.ts';
import { setupSubnav } from './subnav.ts';
import { setupToggles } from './toggles.ts';

export function setup($) {
  setupToggles();
  setupLazyLoad();
  setupFooter();
  setupPersistentBanner();
  stickyHeader();
  setupMainNav($);
  setupSubnav();
  setupBreadcrumbs();
  setupAdvisorModal($);
  setupFindAgent();
  setupCampaignPhone();
}
